module.exports = __webpack_public_path__ + "media/src/assets/Images/PersonIcon-0acb5b36ae126dae251719566934d89a.svg";